// Wariant Wise: kolumny pozycji koszyka w wersji small (modal "carts button").
// Różnice względem columnsSmall: img z fallbackiem na product-no-image gdy thumb wraca 404.

import React, { FC, useState } from 'react';
import { Trans } from 'react-i18next';
import { Trash } from 'react-bootstrap-icons';

import { ICartPositionListItem } from 'api/types';
import { IColumn } from 'components/controls/Table';
import { Availability, Link } from 'components/controls';

import QuantityWrapper from 'components/containers/CartPositions/components/QuantityWrapper';

import productNoImage from 'assets/images/product-no-image.png';
import styles from 'theme/components/containers/CartPositions/CartPositions.module.scss';

const ProductThumb: FC<{ item: ICartPositionListItem }> = ({ item }) => {
  const [errored, setErrored] = useState(false);
  const rawUrl = item.image?.[0]?.thumb || item.image?.[0]?.min;
  const src = !rawUrl || errored ? productNoImage : rawUrl;
  return (
    <div className={styles.productThumb}>
      <Link to={`/${item.url_link}`}>
        <img src={src} alt={item.name} onError={() => setErrored(true)} />
      </Link>
    </div>
  );
};

export const getSmallColumnsWise = ({
  cartId,
  onChange,
  queryParams,
  setItemsToRemove
}: {
  cartId: number;
  onChange?: () => void;
  queryParams: object;
  updatingPositionIds: number[];
  setItemsToRemove: (items: ICartPositionListItem[]) => void;
}): IColumn<ICartPositionListItem>[] => [
  {
    title: '',
    key: 'product-image',
    renderCell: (item) => <ProductThumb item={item} />,
    width: 78
  },
  {
    title: <Trans>Nazwa produktu</Trans>,
    dataIndex: 'name',
    align: 'left',
    renderCell: (item) => (
      <div className={styles.productInfo}>
        <Link to={`/${item.url_link}`}>{item.name}</Link>
        <div className={styles.grey}>{item.index}</div>
        <Availability stock={item.stock} />
      </div>
    )
  },
  {
    title: <Trans>Ilość</Trans>,
    dataIndex: 'quantity',
    align: 'center',
    width: 160,
    renderCell: (item) => (
      <div className={styles.quantityCellWrapper}>
        <QuantityWrapper
          cartId={cartId}
          item={item}
          onChange={onChange}
          queryParams={queryParams}
        />
      </div>
    )
  },
  {
    title: <Trans>Wartość</Trans>,
    dataIndex: 'total_price_net',
    align: 'right',
    renderCell: (item) => (
      <div className={styles.productTotalPrice}>
        {item.total_price_net_formatted} {item.currency}{' '}
        <span className={styles.suffix}>
          <Trans>netto</Trans>
        </span>
        <div className={styles.small}>
          {item.total_price_gross_formatted} {item.currency}{' '}
          <span className={styles.suffix}>
            <Trans>brutto</Trans>
          </span>
        </div>
      </div>
    )
  },
  {
    title: <Trans>Opcje</Trans>,
    key: 'actions',
    align: 'center',
    renderCell: (item) => (
      <div className={styles.actionsWrapper}>
        <Trash onClick={() => setItemsToRemove([item])} />
      </div>
    )
  }
];
